import * as React from 'react';
import { Config } from '../helper';

export default function EmptyPlaceholder() {
  return (
    <div className='nv-learning-pathway-collection--empty'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            {Config.I18n.Empty}
          </div>
        </div>
      </div>
    </div>
  );
}
